var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hello_sales") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.89,
    cy: 8.11,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.05,5.9a2,2,0,0,0-2-2h0L11,4a2.05,2.05,0,0,0-1.41.59L3.39,10.71a2,2,0,0,0,0,2.83l7.07,7.07a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l6.22-6.22A2,2,0,0,0,20.09,13ZM18.8,13.68,12.59,19.9a1,1,0,0,1-1.42,0L4.1,12.83a1,1,0,0,1,0-1.42l6.17-6.16A1,1,0,0,1,11,5l7.08,0h0a1,1,0,0,1,1,1l0,7.06A.94.94,0,0,1,18.8,13.68Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.b862fb94.svg";
export { ForwardRef as ReactComponent };